/** When true, API calls are served from in-memory dummy data (no DB / Netlify functions). */
export function isDevMock(): boolean {
  return import.meta.env.VITE_DEV_MOCK === 'true'
}
